import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { Localization } from 'static/localization/localization';

export const SHOWCASES: {
    iconSet: IconPrefix;
    iconName: IconName;
    title: string;
    demos: {
        img: string;
        title: string;
        desc: string;
        link: string;
    }[];
}[] = [
    {
        iconSet: 'far',
        iconName: 'globe-stand',
        title: Localization.TRAVELLING,
        demos: [
            {
                img: 'https://dvtqxks0zalev.cloudfront.net/app-static/demo1.jpg',
                title: Localization.CABIN_MAP,
                desc: Localization.TRONDHEIM_NORWAY,
                link: 'https://map.mapheim.com/koiene'
            },
            {
                img: 'https://dvtqxks0zalev.cloudfront.net/app-static/demo2.jpg',
                title: Localization.CITY_MAP,
                desc: Localization.TRONDHEIM_NORWAY,
                link: 'https://trondheim.io/?image=1'
            },
            {
                img: 'https://dvtqxks0zalev.cloudfront.net/app-static/demo3.jpg',
                title: Localization.FOOD_FESTIVAL,
                desc: Localization.TRONDHEIM_NORWAY,
                link: 'https://app.mapheim.com/m/seafood'
            }
        ]
    },
    {
        iconSet: 'far',
        iconName: 'list-music',
        title: Localization.FESTIVALS,
        demos: [
            {
                img: 'https://dvtqxks0zalev.cloudfront.net/app-static/demo4.jpg',
                title: Localization.MUSIC_FESTIVAL,
                desc: Localization.GOTA_FAROE_ISLANDS,
                link: 'https://app.mapheim.com/m/gfestival'
            },
            {
                img: 'https://dvtqxks0zalev.cloudfront.net/app-static/demo5.jpg',
                title: Localization.MUSIC_FESTIVAL,
                desc: Localization.TYDAL_NORWAY,
                link: 'https://app.mapheim.com/m/tydals'
            },
            {
                img: 'https://dvtqxks0zalev.cloudfront.net/app-static/demo6.jpg',
                title: Localization.MUSIC_FESTIVAL,
                desc: Localization.LIBEREC_CZECHIA,
                link: 'https://app.mapheim.com/m/benatska'
            }
        ]
    },
    {
        iconSet: 'far',
        iconName: 'store',
        title: Localization.FAIRS,
        demos: [
            {
                img: 'https://dvtqxks0zalev.cloudfront.net/app-static/demo7.jpg',
                title: Localization.JOB_FAIR,
                desc: Localization.AGDER_NORWAY,
                link: 'https://app.mapheim.com/m/uia'
            },
            {
                img: 'https://dvtqxks0zalev.cloudfront.net/app-static/demo8.jpg',
                title: Localization.JOB_FAIR,
                desc: Localization.TRONDHEIM_NORWAY,
                link: 'https://map.mapheim.com/tekno'
            },
            {
                img: 'https://dvtqxks0zalev.cloudfront.net/app-static/demo9.jpg',
                title: Localization.JOB_FAIR,
                desc: Localization.TRONDHEIM_NORWAY,
                link: 'https://app.mapheim.com/m/revolve'
            },
            {
                img: 'https://dvtqxks0zalev.cloudfront.net/app-static/demo10.jpg',
                title: Localization.JOB_FAIR,
                desc: Localization.AARHUS_DENMARK,
                link: 'https://app.mapheim.com/m/kdag'
            }
        ]
    },
    {
        iconSet: 'far',
        iconName: 'ferris-wheel',
        title: Localization.THEME_PARKS,
        demos: [
            {
                img: 'https://dvtqxks0zalev.cloudfront.net/app-static/demo11.jpg',
                title: Localization.FAMILY_PARK,
                desc: Localization.NAMSSKOGAN_NORWAY,
                link: 'https://map.mapheim.com/namsskogan/'
            }
        ]
    },
    {
        iconSet: 'far',
        iconName: 'keynote',
        title: Localization.CONFERENCES,
        demos: [
            {
                img: 'https://dvtqxks0zalev.cloudfront.net/app-static/demo12.jpg',
                title: Localization.CONFERENCE,
                desc: Localization.TRONDHEIM_NORWAY,
                link: 'https://map.mapheim.com/grunder'
            },
            {
                img: 'https://dvtqxks0zalev.cloudfront.net/app-static/demo13.jpg',
                title: Localization.CONFERENCE,
                desc: Localization.HEMSEDAL_NORWAY,
                link: 'https://app.mapheim.com/m/startupextreme'
            }
        ]
    },

    {
        iconSet: 'far',
        iconName: 'briefcase',
        title: Localization.BUSINESS,
        demos: [
            {
                img: 'https://dvtqxks0zalev.cloudfront.net/app-static/demo14.jpg',
                title: Localization.CUSTOMER_MAP,
                desc: Localization.BRNO_CZECHIA,
                link: 'https://app.mapheim.com/m/orca'
            }
        ]
    },
    {
        iconSet: 'far',
        iconName: 'medal',
        title: Localization.SPORT,
        demos: [
            {
                img: 'https://dvtqxks0zalev.cloudfront.net/app-static/demo15.jpg',
                title: Localization.RUNNING_RACE,
                desc: Localization.TRONDHEIM_NORWAY,
                link: 'https://app.mapheim.com/m/fjellseter'
            }
        ]
    }
];
